import Configurator from '../../../configurator'
import store from '../../../admin/store'

/**
 * @abstract
 */
export default class BaseApp extends Configurator {
    /**
     * On mount component
     */
    componentDidMount() {
        this.setWhitelistedFilterRoute()
    }

    /**
     * After component update
     *
     * @param {Object} prevProps
     */
    componentDidUpdate = prevProps => {
        const {
            location,
        } = this.props

        if (location?.pathname !== prevProps?.location?.pathname) {
            this.setWhitelistedFilterRoute()
        }
    }

    /**
     * Set if is route whitelisted or not based on props defined in routes
     */
    setWhitelistedFilterRoute = () => {
        const { whitelistedFilterRoute } = this.props

        store.dispatch({
            type: 'FILTERS_SET_IS_WHITELISTED_ROUTE',
            isWhitelistedRoute: !!whitelistedFilterRoute,
        })
    }
}
